export const SubscriptionPlans = {

    FREE: "free",

    TRIAL: "trial",

    PRO: "pro",

};
